export default "__VITE_ASSET__f6c357da__"